// Librerias.
import React from 'react';
import { Container } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';

// Components Base.
import { Navbar } from '../components-base';

// Assets.

const Hero = () => {
  return (
    <header className="approach_hero approach_hero__bg ">
      <Navbar />
      <Container>
        <h1>
          <FormattedMessage id="apporach.hero" defaultMessage="Nuestro Approach" />
        </h1>
      </Container>
    </header>
  );
};

export default Hero;
